import React from 'react';
import { useNavigate } from 'react-router-dom';
import { getSignedMediaUrl } from '@/lib/utils';
import type { Artist } from '@/features/clubs/types/types';

interface ArtistsSectionProps {
  artists: Artist[];
  clubHandle?: string;
}

const ArtistsSection: React.FC<ArtistsSectionProps> = ({ artists, clubHandle }) => {
  const navigate = useNavigate();

  if (!artists || artists.length === 0) {
    return null;
  }

  const handleArtistClick = (artist: Artist) => {
    if (clubHandle) {
      navigate(`/venues/${clubHandle}/artist/${artist.id}`);
    } else if (artist.business?.handle) {
      navigate(`/venues/${artist.business.handle}/artist/${artist.id}`);
    }
  };

  return (
    <section>
      <h2 className="text-4xl font-serif font-medium text-white mb-8">Featured Artists</h2>
      <div className="space-y-8">
        {artists.map((artist) => (
          <button
            key={artist.id}
            onClick={() => handleArtistClick(artist)}
            className="w-full flex items-center gap-6 hover:bg-gray-900/30 p-4 rounded-lg transition-all duration-200 hover:scale-[1.02] group"
          >
            <div className="w-24 h-24 rounded-full overflow-hidden flex-shrink-0">
              {artist.card_image_id && artist.card_image_id !== '00000000-0000-0000-0000-000000000000' ? (
                <img 
                  src={getSignedMediaUrl(artist.card_image_id, 'image').url} 
                  alt={artist.name} 
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-200"
                />
              ) : (
                <div className="w-full h-full bg-gray-700 flex items-center justify-center group-hover:bg-gray-600 transition-colors duration-200">
                  <span className="text-gray-400 text-xs">No Image</span>
                </div>
              )}
            </div>
            <div className="text-left">
              <h3 className="text-xl font-bold text-white group-hover:text-blue-400 transition-colors duration-200">{artist.name}</h3>
              {artist.description && (
                <p className="text-gray-400 mt-1 group-hover:text-gray-300 transition-colors duration-200">{artist.description}</p>
              )}
            </div>
          </button>
        ))}
      </div>
    </section>
  );
};

export default ArtistsSection;
